import { render, staticRenderFns } from "./AcademyGuidesSearchModal.vue?vue&type=template&id=0561d0ca"
import script from "./AcademyGuidesSearchModal.vue?vue&type=script&lang=js"
export * from "./AcademyGuidesSearchModal.vue?vue&type=script&lang=js"
import style0 from "./AcademyGuidesSearchModal.vue?vue&type=style&index=0&id=0561d0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GuideSearchResultCardSkeleton: require('/skade-pwa/components/ui/atom/skeleton/GuideSearchResultCardSkeleton.vue').default,Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
